import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Box, TextField, Button, Select } from "@mui/material";
import { toast } from "react-toastify";
import { updateAlmacen } from "../../../../services";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { ordenarProvinciasYMunicipios } from "../../../../functions/ordenarListas";
import { municipiosIniciales, cambiarFormatoNombre } from "../../../../functions/funciones";
import LaeButton from "../../../../components/Buttons/LaeButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85ch",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const EditarAlmacen = ({ almacen, opened, handleClose }) => {
  const { t } = useTranslation(['common']);
  const [form, setForm] = useState({});
  const [listadoMunicipios, setListadoMunicipios] = useState([]);

  useEffect(() => {
    if (almacen) {
      setForm({
        nombre: almacen.nombre || '',
        telefono: almacen.telefono || '',
        provincia: almacen.provincia || '',
        municipio: almacen.municipio || '',
        direccion: almacen.direccion || '',
      });
      setListadoMunicipios(
        municipiosIniciales(provinces, municipalities, almacen.provincia)
      );
    }
  }, [almacen]);

  const handleChange = (evt) => {
    setForm({ ...form, [evt.target.name]: evt.target.value });
  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.forEach((p) => {
      if (p.name === e.target.value) codProvincia = p.code;
    });
    setForm({ ...form, [e.target.name]: e.target.value });
    municipalities.forEach((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({ ...m, name: cambiarFormatoNombre(m.name), value: m.name });
      }
    });
    setListadoMunicipios(municipios);
  };

  const handleSubmit = () => {
    if (!form.nombre?.trim()) {
      toast.error(t('almacenes.messages.fieldRequired', { field: 'nombre' }));
      return;
    }
    const toastInfo = toast.info(t('almacenes.messages.saving'), { autoClose: false });
    updateAlmacen(almacen.id, form)
      .then(() => {
        toast.update(toastInfo, {
          render: t('almacenes.messages.editedSuccess'),
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        handleClose();
      })
      .catch((err) => {
        console.log(err);
        toast.update(toastInfo, {
          render: t('almacenes.messages.editError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
      });
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        open={opened}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Box sx={style}>
          <div
            style={{
              backgroundColor: "#fff",
              border: "2px solid #000",
              boxShadow:
                "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
              padding: "16px 32px 24px",
            }}
          >
            <h2 id="transition-modal-title">{t('almacenes.details.edit')}</h2>
            <div id="transition-modal-description">
              <form noValidate autoComplete="off">
                <div
                  style={{
                    margin: "8px",
                    width: "100%",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <TextField
                    name="nombre"
                    label={t('almacenes.columns.almacen')}
                    value={form.nombre || ''}
                    onChange={handleChange}
                  />
                  <TextField
                    name="telefono"
                    label={t('form.phone')}
                    value={form.telefono || ''}
                    onChange={handleChange}
                  />
                  <Select
                    native
                    name="provincia"
                    style={{ textTransform: "uppercase" }}
                    onChange={seleccionarMunicipios}
                    defaultValue={almacen?.provincia}
                  >
                    <option value="">{t('form.province')}</option>
                    {provinces.sort(ordenarProvinciasYMunicipios).map((e, i) => (
                      <option key={i} value={e.name}>{e.name}</option>
                    ))}
                  </Select>
                  <Select
                    native
                    name="municipio"
                    style={{ textTransform: "uppercase" }}
                    onChange={handleChange}
                    defaultValue={almacen?.municipio}
                  >
                    <option value="">{t('form.city')}</option>
                    {listadoMunicipios.sort(ordenarProvinciasYMunicipios).map((e, i) => (
                      <option key={i} value={e.value}>{e.name}</option>
                    ))}
                  </Select>
                  <TextField
                    name="direccion"
                    label={t('form.address')}
                    value={form.direccion || ''}
                    onChange={handleChange}
                  />
                </div>
                <div
                  style={{
                    margin: "8px",
                    marginTop: "16px",
                    position: "relative",
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gridGap: "15px",
                    fontSize: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      flex: 1,
                      backgroundColor: "whitesmoke",
                      color: "#92004D",
                      ":hover": { backgroundColor: "#92004D", color: "white" },
                      margin: 0,
                      p: 1,
                    }}
                    disableElevation
                    onClick={handleClose}
                  >
                    {t('actions.cancel')}
                  </Button>
                  <LaeButton sx={{ flex: 1 }} onClick={handleSubmit}>
                    {t('actions.save')}
                  </LaeButton>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default EditarAlmacen;
